export default __webpack_public_path__ + "static/media/Homepage2.85aac4cb.jpeg";